import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Button, Loading } from 'components';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalSendVaccine extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onActionVaccine, onToggleModal, infection } = this.props;
    const { selectedExamSummaryNo, examSummaryByExamNo, path, targetCount } = this.props;
    let SendTarget = '';

    if (path.get('current') === '/main/exam/pi') {
      SendTarget = (
        <List.Item className={cx('template-detail-item')}>
          <div className={cx('template-detail-item-title')}>
            {defineMessages(formatMessage({ id: 'ModalSendVaccine_3', defaultMessage: '발송 대상' }))}
          </div>
          {targetCount}
          {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
        </List.Item>
      );
    // } else if (path.get('current') === '/main/exam/tag') {
    //   SendTarget = (
    //     <List.Item className={cx('template-detail-item')}>
    //       <div className={cx('template-detail-item-title')}>
    //         {defineMessages(formatMessage({ id: 'ModalSendVaccine_3', defaultMessage: '발송 대상' }))}
    //       </div>
    //       {targetCount}
    //       {defineMessages(formatMessage({ id: 'TargetHeader_4', defaultMessage: '개 태그' }))}
    //     </List.Item>
    //   );
    }
    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-sendVaccine-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ExamHeader_29', defaultMessage: '훈련 대상에게 백신 메일 발송' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ExamTemplateEditModal_4', defaultMessage: '취소' }))}
            </Button>
            <Button
              className={cx('brand-button')}
              disabled={isClicked}
              loading={isClicked}
              onClick={() => !!infection ? onActionVaccine('infectionSend') : onActionVaccine('send')}>
              {defineMessages(formatMessage({ id: 'ModalSendVaccine_1', defaultMessage: '메일 발송' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <Loading active={isClicked} size="small" content="Waiting..." />
          <div className={cx('message-header')}>
            {defineMessages(
              formatMessage({ id: 'ModalSendVaccine_2', defaultMessage: '백신 파일이 첨부된 메일을 발송합니다.' })
            )}
          </div>
          <Message className={cx('template-detail-box')}>
            {/* <Message.Header>
              <div>
                {defineMessages(
                  formatMessage({ id: 'ModalSendVaccine_2', defaultMessage: '백신 파일이 첨부된 메일을 발송합니다.' })
                )}
              </div>
            </Message.Header> */}
            <div className={cx('template-detail')}>
              <List bulleted className={cx('template-detail-list')}>
                <List.Item className={cx('template-detail-item')}>
                  <div className={cx('template-detail-item-title')}>
                    {defineMessages(formatMessage({ id: 'ExamListItem_1', defaultMessage: '훈련명' }))}
                  </div>
                  {examSummaryByExamNo.get(String(selectedExamSummaryNo)).get('examName')}
                </List.Item>
                {!infection ? SendTarget : ''}
              </List>
            </div>
          </Message>
        </div>
      </ModalTemplate>
    );
  }
}

const mapStateToProps = state => ({
  selectedExamSummaryNo: state.currentStatus.getIn(['examSummary', 'selected']),
  path: state.currentStatus.get('path'),
  examSummaryByExamNo: state.examSummary.get('examSummaryByExamNo'),
  targetCount: state.examList.get('totalItem')
});

export default connect(mapStateToProps)(injectIntl(ModalSendVaccine));



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalSendVaccine.js